/* Dermatinta v2 — marquesina progresiva sobre el overflow horizontal original. */
(function () {
  'use strict';
  if (window.DTCinta) { window.DTCinta.mount(document); return; }
  const instances = new Map();
  const GESTURE_MS = 5000;  // tras soltar, la cinta sigue sola a los 5 s (revisión v2, 15-oct noche)
  const rootElement = document.documentElement;
  const media = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function build(s) {
    if (s.clones.length || !s.originals.length) return;
    s.track.setAttribute('data-cinta-bucle', 'true');
    function appendCycle() {
    s.originals.forEach(function (item) {
      const clone = item.cloneNode(true);
      clone.setAttribute('data-cinta-clon', '');
      clone.setAttribute('data-cinta-clone', '');
      Array.from(clone.querySelectorAll('[data-video-toggle]')).forEach(function (control) { control.remove(); });
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.inert = true;
      [clone].concat(Array.from(clone.querySelectorAll('*'))).forEach(function (el) {
        ['id', 'for', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'aria-owns', 'aria-activedescendant', 'headers', 'list', 'form', 'data-shopify-editor-block', 'data-shopify-editor-section'].forEach(function (attr) { el.removeAttribute(attr); });
        if (el.hasAttribute('href') && el.getAttribute('href').charAt(0) === '#') el.removeAttribute('href');
        if (el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
        if (el.hasAttribute('data-src')) el.removeAttribute('src');
      });
      s.track.appendChild(clone);
      s.clones.push(clone);
      if (window.DTVideos && window.DTVideos.mount) window.DTVideos.mount(clone);
    });
    }
    appendCycle();
    s.cycle = s.clones[0].getBoundingClientRect().left - s.originals[0].getBoundingClientRect().left;
    if (s.cycle > 0) {
      const copies = Math.max(1, Math.ceil((s.track.clientWidth + s.originals[0].offsetLeft) / s.cycle));
      for (let i = 1; i < copies; i++) appendCycle();
    }
  }
  function tick(s, time) {
    s.raf = 0;
    if (s.destroyed) return;
    if (!s.section.isConnected) { destroy(s.section); return; }
    if (!s.visible || !s.cycle) return;
    if (s.last !== null) s.position = (s.position + s.speed * Math.min(64, Math.max(0, time - s.last)) / 1000) % s.cycle;
    s.last = time;
    s.track.scrollLeft = s.position;
    s.raf = requestAnimationFrame(function (next) { tick(s, next); });
  }
  function stop(s, removeClones) {
    if (s.raf) cancelAnimationFrame(s.raf);
    s.raf = 0;
    s.last = null;
    if (removeClones && s.clones.length) {
      const position = s.cycle > 0 ? s.track.scrollLeft % s.cycle : s.track.scrollLeft;
      s.clones.forEach(function (clone) {
        if (window.DTVideos && window.DTVideos.destroy) window.DTVideos.destroy(clone);
        clone.remove();
      });
      s.clones = [];
      s.cycle = 0;
      s.track.removeAttribute('data-cinta-bucle');
      s.track.scrollLeft = Math.max(0, Math.min(position, s.track.scrollWidth - s.track.clientWidth));
    }
  }
  function listen(s, target, type, fn, options) {
    target.addEventListener(type, fn, options);
    s.cleanup.push(function () { target.removeEventListener(type, fn, options); });
  }
  function quiet() {
    if (window.DTMotion && window.DTMotion.quiet) return window.DTMotion.quiet();
    const forced = rootElement && rootElement.getAttribute('data-movimiento') === 'forzado';
    return (!media || (media.matches && !forced)) || !!(rootElement && rootElement.getAttribute('data-movimiento-pausado') === 'true');
  }
  function controls(s) {
    const max = Math.max(0, s.track.scrollWidth - s.track.clientWidth);
    if (s.previous) s.previous.disabled = s.track.scrollLeft <= 1;
    if (s.next) s.next.disabled = s.track.scrollLeft >= max - 1;
  }
  // Gestos sobre la cinta (dedo, arrastre, rueda horizontal): pausan mientras duran y ella sigue sola unos segundos después.
  // Antes eran una pausa para siempre y, como la cinta ocupa media pantalla, casi cualquier scroll de la página la mataba.
  function armGesture(s) {
    if (s.gestureTimer) clearTimeout(s.gestureTimer);
    s.gestureTimer = 0;
    if (s.holding || s.destroyed) return;
    s.gestureTimer = setTimeout(function () {
      s.gestureTimer = 0;
      if (s.destroyed) return;
      s.gesture = false;
      refresh(s);
    }, GESTURE_MS);
  }
  function hold(s) {
    s.holding = true;
    s.gesture = true;
    if (s.gestureTimer) { clearTimeout(s.gestureTimer); s.gestureTimer = 0; }
    refresh(s);
  }
  function release(s) {
    if (!s.holding) return;
    s.holding = false;
    armGesture(s);
  }
  function nudge(s) {
    s.gesture = true;
    armGesture(s);
    refresh(s);
  }
  function manual(s, delta) {
    nudge(s);
    s.track.scrollBy({left: delta, behavior: 'auto'});
    controls(s);
  }
  function step(s) {
    const gap = parseFloat(getComputedStyle(s.track).columnGap) || 0;
    return ((s.originals[0] ? s.originals[0].getBoundingClientRect().width : s.track.clientWidth) + gap) * 2;
  }
  function refresh(s) {
    if (s.destroyed) return;
    if (s.pause) {
      s.pause.hidden = !s.section.hasAttribute('data-cinta-auto') || !window.IntersectionObserver || !s.originals.length;
      s.pause.disabled = quiet();
      s.pause.setAttribute('aria-pressed', String(s.userPaused));
      s.pause.setAttribute('aria-label', s.userPaused ? 'Reanudar el desplazamiento automático' : 'Pausar el desplazamiento automático');
    }
    const isQuiet = quiet();
    s.section.setAttribute('data-cinta-estado', isQuiet ? 'quieto' : ((s.userPaused || s.gesture) ? 'pausado' : 'listo'));
    if (s.userPaused || s.focused || isQuiet || (s.section.hasAttribute('data-cinta-movil') && window.innerWidth >= 750)) { stop(s, true); controls(s); return; }
    if (s.gesture) { stop(s, false); controls(s); return; }  // pausa transitoria: conserva las copias y la posición
    if (!s.section.hasAttribute('data-cinta-auto') || !window.IntersectionObserver || !s.originals.length) { stop(s, true); controls(s); return; }
    if (!s.visible || document.hidden) { stop(s, false); return; }
    if (s.visible && s.originals.length && s.section.hasAttribute('data-cinta-auto')) {
      build(s);
      s.position = s.cycle > 0 ? s.track.scrollLeft % s.cycle : 0;
      if (s.cycle > 0 && !s.raf) s.raf = requestAnimationFrame(function (time) { tick(s, time); });
    }
  }
  function mount(root) {
    const sections = root.matches && root.matches('[data-cinta]') ? [root] : Array.from(root.querySelectorAll('[data-cinta]'));
    sections.forEach(function (section) {
      if (instances.has(section)) return;
      const track = section.querySelector('[data-cinta-pista]') || section.querySelector('.cinta__pista');
      if (!track) return;
      const s = {section: section, track: track, raf: 0, visible: false, position: track.scrollLeft, last: null, cycle: 0, clones: [], originals: Array.from(track.children).filter(function (el) { return el.matches('.cinta__item') || el.hasAttribute('data-cinta-item'); })};
      s.speed = Math.min(180, Math.max(8, Number(section.getAttribute('data-cinta-velocidad')) || 120));
      s.cleanup = [];
      s.previous = section.querySelector('[data-cinta-ant]');
      s.next = section.querySelector('[data-cinta-sig]');
      if (s.previous) listen(s, s.previous, 'click', function () { manual(s, -step(s)); });
      if (s.next) listen(s, s.next, 'click', function () { manual(s, step(s)); });
      listen(s, track, 'scroll', function () { controls(s); }, {passive: true});
      listen(s, track, 'keydown', function (event) {
        if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        const deltas = {ArrowLeft: -step(s), ArrowRight: step(s), Home: -track.scrollWidth, End: track.scrollWidth};
        if (!Object.prototype.hasOwnProperty.call(deltas, event.key)) return;
        event.preventDefault();
        manual(s, deltas[event.key]);
      });
      controls(s);
      ['pointerdown', 'touchstart'].forEach(function (type) {
        listen(s, track, type, function () { hold(s); }, {passive: true});
      });
      // Soltar puede ocurrir fuera de la pista: se escucha en window. La rueda vertical mueve la página, no la cinta.
      ['pointerup', 'pointercancel', 'touchend', 'touchcancel', 'blur'].forEach(function (type) {
        listen(s, window, type, function () { release(s); }, {passive: true});
      });
      listen(s, track, 'wheel', function (event) {
        if (event.shiftKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) nudge(s);
      }, {passive: true});
      s.cleanup.push(function () { if (s.gestureTimer) clearTimeout(s.gestureTimer); s.gestureTimer = 0; });
      s.userPaused = false;
      s.gesture = false;
      s.holding = false;
      s.gestureTimer = 0;
      s.focused = track.contains(document.activeElement);
      listen(s, track, 'focusin', function () { s.focused = true; refresh(s); });
      listen(s, track, 'focusout', function (event) { s.focused = !!(event.relatedTarget && track.contains(event.relatedTarget)); refresh(s); });
      s.pause = section.querySelector('[data-cinta-pausa]');
      if (window.DTMotion && window.DTMotion.subscribe) s.cleanup.push(window.DTMotion.subscribe(function () { refresh(s); }));
      else if (media) {
        const changed = function () { refresh(s); };
        if (media.addEventListener) listen(s, media, 'change', changed);
        else if (media.addListener) { media.addListener(changed); s.cleanup.push(function () { media.removeListener(changed); }); }
      }
      if (!window.DTMotion && window.MutationObserver && rootElement) {
        const observer = new window.MutationObserver(function () { refresh(s); });
        observer.observe(rootElement, {attributes: true, attributeFilter: ['data-movimiento', 'data-movimiento-pausado']});
        s.cleanup.push(function () { observer.disconnect(); });
      }
      if (s.pause) listen(s, s.pause, 'click', function () { s.userPaused = !s.userPaused; refresh(s); });
      section.setAttribute('data-cinta-v2', 'true');
      instances.set(section, s);
      refresh(s);
      listen(s, document, 'visibilitychange', function () { refresh(s); });
      const resized = function () {
        stop(s, true);
        refresh(s);
        controls(s);
      };
      if (window.ResizeObserver) {
        s.resize = new window.ResizeObserver(resized);
        s.resize.observe(track);
        s.originals.forEach(function (item) { s.resize.observe(item); });
      } else listen(s, window, 'resize', resized, {passive: true});
      if (window.IntersectionObserver) {
        s.io = new window.IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.target === section) { s.visible = entry.isIntersecting; refresh(s); } });
        });
        s.io.observe(section);
      }
    });
  }
  function destroy(root) {
    instances.forEach(function (s, section) {
      if (root !== section && !(root.contains && root.contains(section))) return;
      s.destroyed = true;
      stop(s, true);
      if (s.io) s.io.disconnect();
      if (s.resize) s.resize.disconnect();
      s.cleanup.forEach(function (fn) { fn(); });
      section.removeAttribute('data-cinta-v2');
      section.removeAttribute('data-cinta-estado');
      instances.delete(section);
    });
  }
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
  window.DTCinta = window.__dtCinta = {
    mount: mount,
    destroy: destroy,
    refresh: function () { instances.forEach(refresh); },
    activas: function () { return instances.size; },
    get rafs() { return Array.from(instances.values()).filter(function (s) { return s.raf; }).length; }
  };
  mount(document);
})();
